<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-select
          :items="subjects"
          :value="selectedSubject"
          @change="changeSubject"
          label="Subject"
        />
      </v-col>
      <v-col
        v-if="assignedWalts.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No WALTs have been recently assigned.
        </v-alert>
      </v-col>

      <template v-if="activeComplete">
        <v-col
          cols="12"
          class="pb-0 pt-0"
          v-for="(assignedWalt, indexIds) in orderedActiveWalts"
          :key="indexIds">
          <spotlight-card-test
            :assigned-walt="assignedWalt"
            :skill-ee="skillEE"
            :enable-comment-button="true"
            :allow-comment="allowComment"
            :hide-working-towards="hideWorkingTowards"
            :custom-title-wt="customTitleWt"
            :show-walt-button-name="showWaltButtonName"
            @open-feedback-dialog="openFeedbackDialog" />
        </v-col>
        <v-col
          cols="12"
          class="pb-0 pt-0"
          v-for="(assignedWalt, indIds) in orderedCompleteWalts"
          :key="indIds">
          <spotlight-card-test
            :assigned-walt="assignedWalt"
            :skill-ee="skillEE"
            :enable-comment-button="true"
            :allow-comment="allowComment"
            :hide-working-towards="hideWorkingTowards"
            :custom-title-wt="customTitleWt"
            :show-walt-button-name="showWaltButtonName"
            @open-feedback-dialog="openFeedbackDialog" />
        </v-col>

      </template>

      <template v-else>
        <v-col
          cols="12"
          class="pb-0 pt-0"
          v-for="(assignedWalt, indexIds) in orderedWalts"
          :key="indexIds">
          <spotlight-card-test
            :assigned-walt="assignedWalt"
            :skill-ee="skillEE"
            :enable-comment-button="true"
            :allow-comment="allowComment"
            :hide-working-towards="hideWorkingTowards"
            :custom-title-wt="customTitleWt"
            :show-walt-button-name="showWaltButtonName"
            @open-feedback-dialog="openFeedbackDialog" />
        </v-col>
      </template>

    </v-row>

    <v-dialog
      v-model="commentDialog"
      v-if="allowComment">
      <v-card>
        <v-card-title class="pb-0 subtitle-1">Feedback</v-card-title>
        <v-card-text
          class="red--text pt-0 pb-0"
          v-if="commentErrorMsg !== ''">{{ commentErrorMsg }}</v-card-text>
        <v-card-text class="pb-0">
          <v-textarea
            auto-grow
            rows="3"
            name="comment-input"
            label="Enter a comment"
            v-model="comment"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click.native="commentDialog = false; comment = ''; commentErrorMsg = ''">Close</v-btn>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click.native="saveComment()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="feedbackDialog"
      max-width="290px"
      v-else>
      <v-card>
        <v-card-title>Feedback</v-card-title>
        <v-card-text>
          <v-row
            class="fill-height"
            align="center"
            justify="space-around"

          >
            <v-tooltip
              top
              v-for="(feedback, i) in possibleFeedback"
              :key="i">
              <v-btn
                icon
                @click="saveFeedback(feedback.message)"
                slot="activator">
                <v-icon>{{ feedback.icon }}</v-icon>
              </v-btn>
              <span>{{ feedback.message }}</span>
            </v-tooltip>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click.native="feedbackDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import SpotlightCardTest from '../components/SpotlightCardTest'

var orderBy = require('lodash.orderby')

export default {
  components: {
    SpotlightCardTest
  },
  data: () => ({
    assignedWalts: {},
    skillEE: {},
    panel: [],
    subjects: ['ALL'],
    selectedSubject: 'ALL',

    hideWorkingTowards: false,

    allowComment: true,
    commentPSID: 0,
    commentTaskId: 0,

    // Comment dialog
    commentDialog: false,
    comment: '',
    commentErrorMsg: '',

    // Emoji feedback dialog
    feedbackDialog: false,
    possibleFeedback: [
      {
        icon: 'far fa-star',
        message: 'You\'re a star!'
      },
      {
        icon: 'far fa-heart',
        message: 'Love it!'
      },
      {
        icon: 'far fa-thumbs-up',
        message: 'Good job!'
      },
      {
        icon: 'far fa-smile',
        message: 'Awesome! :)'
      }
    ],
    customTitleWt: '',
    showWaltButtonName: 'WALTs',

    activeWalts: {},
    completeWalts: {},
    activeComplete: false

  }),

  computed: {
    orderedWalts: function () {
      if (Object.keys(this.assignedWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.assignedWalts[Object.keys(this.assignedWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.assignedWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.assignedWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.assignedWalts, 'date_started', 'desc')
        }
      } else {
        return this.assignedWalts
      }
    },
    orderedCompleteWalts: function () {
      if (Object.keys(this.completeWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.completeWalts[Object.keys(this.completeWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.completeWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.completeWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.completeWalts, 'date_started', 'desc')
        }
      } else {
        return this.completeWalts
      }
    },
    orderedActiveWalts: function () {
      if (Object.keys(this.activeWalts).length > 0) { // Check if assignedwalts array is not empty
        let obj = this.activeWalts[Object.keys(this.activeWalts)[0]]

        if ('sort_date' in obj) {
          return orderBy(this.activeWalts, 'sort_date', 'desc')
        } else if ('date_published' in obj) { // Checking if date_published exists in obj, sort by published date if it is
          return orderBy(this.activeWalts, 'date_published', 'desc')
        } else {
          return orderBy(this.activeWalts, 'date_started', 'desc')
        }
      } else {
        return this.activeWalts
      }
    }
  },

  methods: {

    // trimHttpPrefix: function (stringToTrim) {
    //   stringToTrim = stringToTrim.replace(/(http)?(s)?(:\/\/)?(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, '$4') // Remove http prefix for prettier url
    //   var length = 30
    //   return stringToTrim.length > length
    //     ? stringToTrim.substring(0, length - 3) + '...'
    //     : stringToTrim
    // },

    changeSubject: function (selection) {
      if (selection !== this.selectedSubject) {
        this.selectedSubject = selection

        this.$store.commit('loading', true)
        // this.$http.get('https://www.atschool.co.nz/api/v2/pupils/' + this.$store.state.pupilId + '/spotlight/recentTest/' + this.selectedSubject)
        this.$http.get('pupils/' + this.$store.state.pupilId + '/spotlight/recentEvidence/' + this.selectedSubject)
          .then(resp => {
            this.assignedWalts = resp.data.assignedWalts

            if (resp.data.activeComplete === true) {
              this.activeComplete = resp.data.activeComplete
              this.completeWalts = resp.data.completeWaltsToShow
              this.activeWalts = resp.data.activeWaltsToShow
            }
            this.skillEE = resp.data.skill_EE
            this.$store.commit('loading', false)
          })
      }
    },

    openFeedbackDialog: function (psid, taskid) {
      this.commentPSID = psid
      this.commentTaskId = taskid

      if (this.allowComment) {
        this.commentDialog = true
      } else {
        this.feedbackDialog = true
      }
    },

    saveComment: function () {
      this.$store.commit('loading', true)
      var comment = this.comment
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var taskid = this.commentTaskId
      var pupilCommentId = this.$store.state.pupilId

      if (comment !== '') {
        this.$http.post('spotlight/postComment', {
          'psid': psid,
          'content': comment,
          'caregiverId': cid,
          'taskId': taskid,
          'pupilCommentId': pupilCommentId
        })
          .then(resp => {
            if (resp.data.success) {
            // Create comments array if it doesn't exist

              Object.keys(this.assignedWalts).forEach(key => {
                console.log(this.assignedWalts[key])
                var mainarr = this.assignedWalts[key]

                if (mainarr.psid === psid && taskid === 0) {
                  this.assignedWalts[key].learning = (typeof this.assignedWalts[key].learning !== 'undefined' && this.assignedWalts[key].learning instanceof Array) ? this.assignedWalts[key].learning : []

                  this.assignedWalts[key].learning.unshift({
                    author: this.$store.state.parentName,
                    content: resp.data.content,
                    formattedDate: resp.data.formattedDate,
                    type: 'Parent'
                  })
                }
              })

              // this.assignedWalts[psid].learning = (typeof this.assignedWalts[psid].learning !== 'undefined' && this.assignedWalts[psid].learning instanceof Array) ? this.assignedWalts[psid].learning : []

              // this.assignedWalts[psid].learning.unshift({
              //   author: this.$store.state.parentName,
              //   content: resp.data.content,
              //   formattedDate: resp.data.formattedDate,
              //   type: 'Parent'
              // })
              this.commentDialog = false
              this.comment = ''
              this.commentErrorMsg = ''
              this.commentPSID = 0
              this.$store.commit('loading', false)
            } else {
              this.commentErrorMsg = 'Something happen'
              this.$store.commit('loading', false)
            }
          })
      } else {
        this.commentErrorMsg = 'Comment cannot be blank. Please enter a comment before saving.'
        this.$store.commit('loading', false)
      }
    },

    saveFeedback: function (message) {
      this.$store.commit('loading', true)
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var pupilCommentId = this.$store.state.pupilId
      var taskid = this.commentTaskId

      this.$http.post('spotlight/postComment', {
        'psid': psid,
        'content': message,
        'caregiverId': cid,
        'taskId': taskid,
        'pupilCommentId': pupilCommentId

      })
        .then(resp => {
          if (resp.data.success) {
            Object.keys(this.assignedWalts).forEach(key => {
              console.log(this.assignedWalts[key])
              var mainarr = this.assignedWalts[key]

              if (mainarr.psid === psid && taskid === 0) {
                this.assignedWalts[key].learning = (typeof this.assignedWalts[key].learning !== 'undefined' && this.assignedWalts[key].learning instanceof Array) ? this.assignedWalts[key].learning : []

                this.assignedWalts[key].learning.unshift({
                  author: this.$store.state.parentName,
                  content: resp.data.content,
                  formattedDate: resp.data.formattedDate,
                  type: 'Parent'
                })
              }
            })

            // Create comments array if it doesn't exist
            // this.assignedWalts[psid].comments = (typeof this.assignedWalts[psid].comments !== 'undefined' && this.assignedWalts[psid].comments instanceof Array) ? this.assignedWalts[psid].comments : []

            // this.assignedWalts[psid].comments.unshift({
            //   author: this.$store.state.parentName,
            //   content: resp.data.content,
            //   date: resp.data.date,
            //   type: 'Parent'
            // })
            this.feedbackDialog = false
            this.commentPSID = 0
            this.$store.commit('loading', false)
          }
        })
    }

  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get config for allow parent comments
      vm.$http.get('config/atschoolSpotlightDisableParenCmt')
        .then(resp => {
          if (resp.data.configValue) {
            vm.allowComment = false
          } else {
            vm.allowComment = true
          }
        })
      // Get Subjects
      vm.$http.get('spotlightSubjects')
        .then(resp => {
          vm.subjects = vm.subjects.concat(resp.data)
        })
      // Get WALTs
      vm.$http.get('pupils/' + vm.$store.state.pupilId + '/spotlight/recentEvidence')
        .then(resp => {
          vm.assignedWalts = resp.data.assignedWalts

          if (resp.data.activeComplete === true) {
            vm.activeComplete = resp.data.activeComplete
            vm.completeWalts = resp.data.completeWaltsToShow
            vm.activeWalts = resp.data.activeWaltsToShow
          }

          Object.keys(vm.assignedWalts).map((value, key) => {
            if (!vm.subjects.includes(vm.assignedWalts[value].subject)) {
              vm.subjects.push(vm.assignedWalts[value].subject)
            }
          })
          vm.skillEE = resp.data.skill_EE
          if (resp.data.hide_working_towards === true) {
            vm.hideWorkingTowards = true
          }

          vm.customTitleWt = resp.data.custom_title_wt
          if (resp.data.showWaltButtonName !== '') {
            vm.showWaltButtonName = resp.data.showWaltButtonName
          }
          // if (in_array() ) {
          //   vm.hideWaltsSubject = true
          // }
          vm.$store.commit('loading', false)
        })
    })
  },

  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
